import { render, staticRenderFns } from "./FilterableDataTable.vue?vue&type=template&id=2806f54c"
import script from "./FilterableDataTable.vue?vue&type=script&lang=js"
export * from "./FilterableDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports